/**
 * @external {node-opcua} http://node-opcua.github.io/api_doc/0.1.0/
 */

/**
 * @external {node-opcua~NodeId} http://node-opcua.github.io/api_doc/0.1.0/classes/NodeId.html
 */

/**
 * @external {node-opcua~NodeIdType} http://node-opcua.github.io/api_doc/0.1.0/classes/NodeIdType.html
 */

/**
 * @external {node-opcua~OPCUAClient} http://node-opcua.github.io/api_doc/0.1.0/classes/OPCUAClient.html
 */

/**
 * @external {node-opcua~ClientSession} http://node-opcua.github.io/api_doc/0.1.0/classes/ClientSession.html
 */

/**
 * @external {node-opcua~ClientSubscription} http://node-opcua.github.io/api_doc/0.1.0/classes/ClientSubscription.html
 */

/**
 * @external {node-opcua~DataValue} http://node-opcua.github.io/api_doc/0.1.0/classes/DataValue.html
 */

/**
 * @external {node-opcua~ReferenceDescription} http://node-opcua.github.io/api_doc/0.1.0/classes/ReferenceDescription.html
 */

/**
 * @external {node-opcua~Variant} http://node-opcua.github.io/api_doc/0.1.0/classes/Variant.html
 */

/**
 * @external {node-opcua~DataType} https://github.com/node-opcua/node-opcua/blob/master/packages/node-opcua-variant/source/DataType_enum.ts
 */

/**
 * @external {node-opcua~VariantArrayType} https://github.com/node-opcua/node-opcua/blob/master/packages/node-opcua-variant/source/VariantArrayType_enum.ts
 */

/**
 * @external {node-opcua~StatusCodes} https://github.com/node-opcua/node-opcua/blob/v0.0.60/lib/raw_status_codes.js
 */

/**
 * @external {node-opcua~CallMethodRequest} http://node-opcua.github.io/api_doc/0.1.0/classes/CallMethodRequest.html
 */

/**
 * @external {node-opcua~ReferenceTypeId} https://github.com/node-opcua/node-opcua/blob/608771099fbfaa42195e150bdf36956affbb53e9/packages/node-opcua-constants/src/opcua_node_ids.js
 */

/**
 * @external {node-opcua~NodeClass} https://github.com/node-opcua/node-opcua/blob/608771099fbfaa42195e150bdf36956affbb53e9/packages/node-opcua-data-model/schemas/NodeClass_enum.js
 */
